/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Footer_Badges_DescriptionInputs */

const en_admin_footer_badges_description = /** @type {(inputs: Admin_Footer_Badges_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manage the badge links shown in your site footer.`)
};

/**
* | output |
* | --- |
* | "Manage the badge links shown in your site footer." |
*
* @param {Admin_Footer_Badges_DescriptionInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_footer_badges_description = /** @type {((inputs?: Admin_Footer_Badges_DescriptionInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Footer_Badges_DescriptionInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_footer_badges_description(inputs)
});
export { admin_footer_badges_description as "admin.footer_badges.description" }